module.exports = __webpack_public_path__ + "static/media/Artboard 1 copy 124.cbe19f9a.png";